module.exports = __webpack_public_path__ + "img/goal-icon.f74bb955.svg";